/**
 * @generated SignedSource<<6d0a5d38ae0f2e6fcda303c6577a93e1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileInfo_query$data = {
  readonly currentUser: {
    readonly isMetricSystem: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProfileInfo_query";
};
export type ProfileInfo_query$key = {
  readonly " $data"?: ProfileInfo_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileInfo_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileInfo_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMetricSystem",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cf6c58402ac05da98e899ebfdf3c17b6";

export default node;
